import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import classes from './FeaturedPage.module.scss';
import {isMobileOnly, isTablet} from "react-device-detect";
import JIcon from "../../components/UI/Icon/JIcon";
import scrollToComponent from "react-scroll-to-component";
import HomeBreadcrumb from "../../components/UI/HomeButton/HomeBreadcrumbHook";
import CountSortingContainer from "../../components/UI/CountSortingContainer/CountSortingContainer";
import Categories from "./Categories/CategoriesHook";
import ReactGa from "react-ga";
import Pagination from "../../components/UI/Pagination/Pagination";
import {LoadingSimple} from "../../components/UI/LoadingBar";
import {utilScrollUp} from "../../utils/Utils";
import {FormattedMessage} from "react-intl";
import {LANG_EN} from "../../constants";
import {Context} from "../../context/Wrapper";
import {Helmet} from "react-helmet";

const Product = React.lazy(() => import('../ProductCategoryPage/Products/Product/Product'))

const FeaturedPage = (props) => {
    const context = useContext(Context);

    const [defaultData, setDefaultData] = useState([])
    const [defaultOps, setDefaultOps] = useState(0)
    // const [postPerPage] = useState(isMobileOnly || isTablet ? 12 : process.env.REACT_APP_DATA_PER_PAGE)
    // const [currentPage, setCurrentPage] = useState(1)
    const [productCategories, setProductCategories] = useState([])
    const [options] = useState([
        {displayId: '-Pilih-', displayValue: '-Choose Sorting-', value: 0},
        {displayId: 'Nama (A-z)', displayValue: 'Name (A-z)', value: 1},
        {displayId: 'Nama (Z-a)', displayValue: 'Name (Z-a)', value: 2},
    ])
    const [categories, setCategories] = useState([
        {id: 0, labelId: 'Terbaru', label: 'New', value: 'is_new', is_checked: false},
        {id: 1, labelId: 'Terfavorit', label: 'Favourite', value: 'is_fav', is_checked: false}
    ])
    // const [categoriesId, setCategoriesId] = useState([
    //     {id: 0, label: 'Terbaru', value: 'is_new', is_checked: false},
    //     {id: 1, label: 'Terfavorit', value: 'is_fav', is_checked: false}
    // ])
    const [state, setState] = useState({
        done: false
        , done_list: undefined
        , categories: []
        , home_product_categories: []
        , all_products: []
        , founded_products: []
        , checked: [
            {display_value: "New", value: 1, isChecked: true, index: 0},
            {display_value: "Favourite", value: 2, isChecked: true, index: 1},
        ]
        , currentPage: 1
        , postPerPage: isMobileOnly || isTablet ? 12 : 15
        , isChecks: true
        , showUnder: false
    });

    const gotoSomewhere = (category_slug, category_id, sub_category_slug, sub_category_id, category_title) => {
        // props.history.push('/product-categories/' + id);
        localStorage.setItem("selected_category_id", category_id);
        localStorage.setItem("selected_category", category_slug);
        localStorage.setItem("selected_sub_category", sub_category_slug);
        localStorage.setItem("selected_sub_category_id", sub_category_id);
        localStorage.setItem("ct_param_product_category", category_title);

        props.history.push({
            pathname: '/product-categories/' + category_slug
            , search: '?selected_sub_category=' + sub_category_slug
        });
    }

    const onSortHandler = (event) => {
        const value = event.target.value;
        switch (+value) {
            case (1) :
                const tempFoundedProducts1 = [...state.founded_products];
                setDefaultOps(value)
                setState({...state, done_list: true, founded_products: tempFoundedProducts1.sort((a, b) => +(a.name > b.name) || -(a.name < b.name))});
                break
            case (2) :
                const tempFoundedProducts2 = [...state.founded_products];
                setDefaultOps(value)
                setState({...state, done_list: true, founded_products: tempFoundedProducts2.sort((a, b) => +(a.name < b.name) || -(a.name > b.name))});
                break
            case (0) :
                const tempFoundedProducts0 = [...defaultData];
                setDefaultOps(value)
                setState({
                    ...state
                    , done_list: true
                    , founded_products: tempFoundedProducts0.sort((a, b) => +(a.name > b.name) || -(a.name < b.name))
                });
                break
            default:
                return null;
        }
    }

    const onFilterHandler = async (event) => {
        event.preventDefault();
        // const datas = context && context.locale === LANG_EN ? [...categories] : [...categoriesId]
        const datas = [...categories]
        const dataIndex = datas.findIndex(x => x.value === event.target.value);

        const dataSelectedIndex = {...datas[dataIndex]}
        dataSelectedIndex.is_checked = event.target.checked;
        const dataWithChecked = [...datas];
        dataWithChecked[dataIndex] = dataSelectedIndex;

        setDefaultOps(0)
        setCategories(dataWithChecked);
        const header = {headers: {'language': context.locale}};
        {
            const data = new FormData();
            dataWithChecked.filter(x => x.is_checked === true).map(x => {
                if (x.value === 'is_new') {
                    data.append('is_new', 1);
                } else if (x.value === 'is_fav') {
                    data.append('is_fav', 1);
                } else {
                    data.append('is_new', 1);
                    data.append('is_fav', 1);
                }
                return null;
            });

            /*================================================
            *
            * */
            const check1 = dataWithChecked[0].is_checked;
            const check2 = dataWithChecked[1].is_checked;
            if(check1 === false && check2 === false){
                data.append('is_new', 1);
                data.append('is_fav', 1);
            }
            /*================================================*/

            const newFilter = async () => {
                await axios.post('featured_product_filter', data, header).then(response => {
                    setState({
                        ...state
                        , done_list: true
                        , founded_products: response.data.featured_products
                        , currentPage: 1
                    })
                }).catch(e => {
                    //
                })
            }
            newFilter()
        }
    }

    useEffect(() => {
        //=================================================
        // console.log('useEffect 1');
        //=================================================
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        const loadDocumentTitle = () => {
            document.title = "Featured Products | Japfa Food | Indonesia | Food Supplier"
        }
        window.scrollTo(0, 0);

        const ourRequest = axios.CancelToken.source()
        const fetchData = async () => {
            const header = {headers: {'language': context.locale}};

            const featured_products = await axios.get('featured_products', header);
            const temp_data = featured_products.data.featured_products.map(x => {
                return {...x, is_checked: false}
            })

            setState({
                ...state
                , done_list: true
                , done: true
                , founded_products: temp_data
                , currentPage: 1
                , defaultOps: 0
            });

            setDefaultData(temp_data)

            // const product_categories = await axios.get('product_categories', header);
            // setProductCategories(product_categories.data.product_categories)
        }
        try {
            loadDocumentTitle()
            setDefaultOps(0)
            setCategories([
                {id: 0, labelId: 'Terbaru', label: 'New', value: 'is_new', is_checked: false},
                {id: 1, labelId: 'Terfavorit', label: 'Favourite', value: 'is_fav', is_checked: false}
            ])
            fetchData()
        } catch (e) {

        }

        return () => {
            ourRequest.cancel();
        }
        //eslint-disable-next-line
    }, [props.location.pathname, props.history, props.match.params.id, context.locale]);

    useEffect(() => {
        //=================================================
        // console.log('useEffect 2');
        //=================================================
        const ourRequest = axios.CancelToken.source();
        const fetchProdCategories = async () => {
            const header = {headers: {'language': context.locale}};
            const product_categories = await axios.get('product_categories', header, {cancelToken: ourRequest.token});
            setProductCategories(product_categories.data.product_categories)
        }
        try {
            fetchProdCategories()
            // setState({...state, currentPage: 1})
        } catch (e) {

        }
        //hooks cleanup
        return () => {
            ourRequest.cancel() // <-- 3rd step
        }
    }, [context.locale])

    let localProducts = <p>No Data Found</p>;
    let pagination = null;
    // if (state.founded_products.length > 0) {
    //Get Current Post
    const indexOfLastData = state.currentPage * state.postPerPage;
    const indexOfFirstData = indexOfLastData - state.postPerPage;
    const currentData = state.founded_products &&
        state.founded_products.slice(indexOfFirstData, indexOfLastData);
    const paginate = (pageNumber) => {
        // setCurrentPage(pageNumber);
        setState({...state, currentPage: pageNumber});
        // setState({currentPage: pageNumber});
        utilScrollUp()
    };
    const paginateNext = () => {
        // setCurrentPage(state.currentPage + 1);
        setState({...state, currentPage: state.currentPage + 1})
        // setState({currentPage: state.currentPage + 1})
        utilScrollUp()
    };
    const paginatePrev = () => {
        // setCurrentPage(state.currentPage - 1);
        setState({...state, currentPage: state.currentPage - 1})
        // setState({currentPage: state.currentPage - 1})
        utilScrollUp()
    };
    const pageStart = (pageNumber) => {
        // setCurrentPage(pageNumber);
        setState({...state, currentPage: pageNumber});
        // setState({currentPage: pageNumber});
        utilScrollUp()
    };
    const pageEnd = (pageNumber) => {
        // setCurrentPage(pageNumber);
        setState({...state, currentPage: pageNumber});
        // setState({currentPage: pageNumber});
        utilScrollUp()
    };

    pagination = <Pagination postPerPage={state.postPerPage}
                             totalData={state.founded_products && state.founded_products.length}
                             currentPage={state.currentPage}
                             paginate={paginate}
                             paginateNext={paginateNext}
                             paginatePrev={paginatePrev}
                             pageStart={pageStart}
                             pageEnd={pageEnd}
    />;

    localProducts = currentData.map((prod, index) => {
        return (
            <li key={`${prod.product_cd}${index}`}
                className={classes.Card_container_li}>
                <React.Suspense fallback={'Load products...'}>
                    <Product prod={prod}/>
                </React.Suspense>
            </li>
        );
    });
    // }

    // const datas = context && context.locale === LANG_EN ? [...categories] : [...categoriesId];
    const datas = [...categories];
    const listCategory = datas.map((x, index) => {
        return (
            <li key={index}>
                <input
                    id={x.id}
                    type="checkbox"
                    checked={x.is_checked}
                    value={x.value}
                    onChange={(e) => onFilterHandler(e)}/>
                <label htmlFor={x.id}>
                    {context.locale === LANG_EN ? x.label : x.labelId}
                </label>
            </li>)
    })

    return (
        <>
            <div className={["violet", classes.FeaturedPage_container].join(' ')} ref={(section) => {
                scrollToComponent.Violet = section;
            }}>
                <Helmet>
                    <meta name="description"
                          content={"Featured Products | Japfa Food | Indonesia | Food Supplier"}/>
                    <meta name="keywords" content={"frozen food, meat shop, Chicken shop, supplier frozen food, food service, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, food solutions, JBFS, Food Supplier"}/>
                    <meta name="author" content=""/>
                    <meta property="og:title"
                          content={"Featured Products | Japfa Food | Indonesia | Food Supplier"}/>
                    <meta property="og:description"
                          content={"Featured Products | Japfa Food | Indonesia | Food Supplier"}/>
                    <title>{'Featured Products | Japfa Food | Indonesia | Food Supplier'}</title>
                    <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
                </Helmet>

                {/*Bread crumbs region*/}
                <section className={[classes.FeaturedPage_sectionBread].join(' ')}>
                    <div className={["jbfs-wrapper", classes.FeaturedPage_wrapperBread].join(' ')}>
                        <div className={["jbfs-breadcrumb-row",].join(' ')}>
                            <HomeBreadcrumb/>
                            <span>/</span>
                            <div><FormattedMessage id={"featuredpage.title"} defaultMessage={"Featured Products"}/></div>
                        </div>
                    </div>
                </section>
                {/*Bread crumbs region*/}

                <section className={classes.FeaturedPage_sectionHeader}>
                    <div className={["jbfs-wrapper", classes.FeaturedPage_wrapperHeader].join(' ')}>
                        <div>
                            <h1><FormattedMessage id={"featuredpage.title"} defaultMessage={"Featured Products"}/></h1>
                            <p><FormattedMessage id={"featuredpage.description"}
                                                 defaultMessage={"Find out our {new} and {fav} products here."}
                                                 values={{
                                                     new: <strong><FormattedMessage id={"global.new"} defaultMessage={"New"}/></strong>,
                                                     fav: <strong><FormattedMessage id={"global.fav"} defaultMessage={"Favourite"}/></strong>
                                                 }}>
                            </FormattedMessage>
                            </p>
                        </div>
                    </div>
                </section>

                <section className={classes.FeaturedPage_section}>
                    <div className={["jbfs-wrapper", classes.Wrapper_container].join(' ')}>

                        <div className={classes.Content_wrapper_main}>

                            <div className={classes.Content_wrapperLeft}>
                                <div className={["", classes.ProductFilter_container].join(' ')}>

                                    {/*ORANGE FILTER SECTION*/}
                                    <section className={classes.Filter_section}>

                                        <div className={classes.SelectedTitle_row}>
                                            <div className={classes.SelectedTitle_pipe}/>
                                            <FormattedMessage id={"featuredpage.title"} defaultMessage={"Featured Products"}/>
                                        </div>

                                        <div className={[classes.header, classes.ProductFilter_card].join(' ')}>
                                            <div><FormattedMessage id={"featuredpage.filter"} defaultMessage={"Filter by Category"}/></div>

                                            {/*Desktop Version*/}
                                            <ul>
                                                {listCategory}
                                            </ul>
                                            {/*Desktop Version*/}
                                        </div>
                                    </section>
                                    {/*ORANGE FILTER SECTION*/}

                                    <section className={[classes.footer, classes.Others_section].join(' ')}>

                                        {/*Will hide for Mobile Version
                                               =============================================================*/}
                                        <div className={classes.Others_item}>
                                            {/*{!state.done_product_categories ?*/}
                                            {/*    (<ReactLoading type={"bars"} color={"#FF6600"} className={"loading-margin"}/>)*/}
                                            {/*    :*/}
                                            {/*    <Categories*/}
                                            {/*        data={productCategories}*/}
                                            {/*        gotoSomewhere={gotoSomewhere}/>*/}
                                            {/*}*/}
                                            <Categories
                                                data={productCategories}
                                                gotoSomewhere={gotoSomewhere}/>
                                        </div>
                                        {/*Will hide for Mobile Version
                                               =============================================================*/}
                                    </section>
                                </div>
                            </div>


                            <div className={classes.Content_wrapperRight}>
                                <CountSortingContainer
                                    data={state.founded_products}
                                    label={<FormattedMessage id={"global.products.title"} defaultMessage={"Products"}/>}
                                    options={options}
                                    onSortHandler={onSortHandler}
                                    defaultOps={defaultOps}
                                />
                                {!state.done_list ?
                                    (<LoadingSimple/>)
                                    :
                                    (<ul className={classes.ProductsCard_wrapper}>
                                        {localProducts}
                                    </ul>)
                                }
                            </div>

                        </div>

                    </div>
                    <div className={["jbfs-wrapper", "jbfs-paging-container"].join(' ')}>
                        {pagination}
                    </div>


                    {/*Will SHOW for Mobile Version
                        =============================================================*/}
                    <div className={classes.Mobile_component_container}>
                        {!state.done_list ?
                            (<LoadingSimple/>)
                            :
                            <Categories
                                data={productCategories}
                                gotoSomewhere={gotoSomewhere}/>
                        }
                    </div>
                    {/*Will SHOW for Mobile Version
                        =============================================================*/}

                </section>

                <div className={["jbfs-arrow-top",].join(' ')}>
                    <JIcon icontype={"link_to_top"}
                           onClick={() => scrollToComponent(scrollToComponent.Violet, {offset: -99, align: 'top', duration: 1500})}/>
                </div>
            </div>
        </>
    )
}

export default FeaturedPage